// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";

export class NotNaNValueConverter implements IValueConverter<number, number> {
    public toView(value: number): number {
        return isNaN(value) ? 0 : value;
    }

    public fromView(value: number): number {
        throw new NotSupportedError("Not supported");
    }
}
